import React, { createContext } from 'react';

const GlobalContext = createContext({});
const FilterItemContext = createContext({});

export { GlobalContext, FilterItemContext };
